export default __webpack_public_path__ + "static/media/hht2_ep2_speaking_01.39efb933.png";